import AxiosInstance from 'src/shared/services/axios/interceptor';
import { AssociationStats } from 'src/shared/models/association/associationStats';
import { Association } from 'src/shared/models/association/association';
import { PagedResult } from 'src/shared/models/pagedResult';
import { AssociationUserResponse } from 'src/modules/associations/models/associationUserResponse';
import { AssocationTitleResponse } from 'src/modules/associations/models/assocationTitleResponse';
import { AssociationTitleRequest } from 'src/modules/associations/models/associationTitleRequest';
import { AssocationTitleConfigRequest } from 'src/modules/associations/models/associationTitleConfigRequest';
import { AssocationTitleConfigResponse } from 'src/modules/associations/models/assTitle';
import { AssociationRequest } from 'src/modules/associations/models/associationRequest';
import { AssociationResponse } from 'src/modules/associations/models/associationResponse';
import { AssociationFeeRequest } from 'src/modules/associations/models/associationFeeRequest';
import { AssociationFee } from 'src/modules/associations/models/associationFee';
import { AssociationSearchFilter } from 'src/modules/associations/models/associationSearchFilter';
import { setPagingParams } from '../functions/createPagingParams';

const controller = 'Association';

export const getAssociationStats = (id) => {
  const endpoint = `${controller}/${id}/stats`;
  return AxiosInstance.get<AssociationStats>(endpoint);
};

export const getAssociations = (districtId?, searchFilter?: AssociationSearchFilter) => {
  let endpoint = `${controller}?pageSize=10000`;

  if (districtId && !searchFilter) {
    endpoint += `&districtId=${districtId}`;
  } else if (searchFilter && !districtId) {
    endpoint = `${controller}/?${setPagingParams({
      pageIndex: searchFilter.pageIndex ?? 0,
      pageSize: searchFilter.pageSize ?? 25,
      sortCol: searchFilter.sortCol ?? '',
      sortDir: searchFilter.sortDir ?? 'asc',
    })}`;

    endpoint += searchFilter.filter ? `&filter=${searchFilter.filter}` : '';
    if (searchFilter.status !== undefined && searchFilter.status !== null) {
      endpoint += `&status=${searchFilter.status}`;
    }
  }

  return AxiosInstance.get<PagedResult<Association>>(endpoint);
};

export const getAssociationById = (id: string | undefined) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<AssociationResponse>(endpoint);
};

export const getAssociationFeeById = (id: string | undefined) => {
  const endpoint = `${controller}/${id}/fee`;
  return AxiosInstance.get<AssociationFee>(endpoint);
};

export const updateAssociation = (data: AssociationRequest) => {
  return AxiosInstance.put(controller, data);
};

export const getAssociationUsers = (id: string | undefined) => {
  return AxiosInstance.get<AssociationUserResponse[]>(`${controller}/${id}/User`);
};

export const getAssociationTitleByType = (id: string | undefined, type: number) => {
  return AxiosInstance.get<AssocationTitleResponse[]>(`${controller}/${id}/Title/${type}`);
};

export const updateAssociationTitle = (id: string | undefined, data: AssociationTitleRequest) => {
  return AxiosInstance.put(`${controller}/${id}/Title`, data);
};

export const getAssociationTitleConfigByType = (id: string | undefined, type: number) => {
  return AxiosInstance.get<AssocationTitleConfigResponse[]>(`${controller}/${id}/TitleConfig/${type}`);
};

export const updateAssociationTitleConfig = (id: string | undefined, data: AssocationTitleConfigRequest) => {
  return AxiosInstance.put(`${controller}/${id}/TitleConfig`, data);
};

export const updateAssociationFee = (data: AssociationFeeRequest) => {
  return AxiosInstance.put(`${controller}/${data.localAss_id}/fee`, data);
};
